export const CONTACT_US_CALENDLY_URL =
  "https://calendly.com/amy-janerothe/marketing";

export const EMAIL_EXIST = "resource_already_exists";
